module.exports = __webpack_public_path__ + "static/media/helpAnd Support.2349710a.svg";